import * as React from "react";
import { event, select } from "d3-selection";
import * as d3 from "./assets/d3";
var Cursor;
(function (Cursor) {
    Cursor["hand"] = "hand";
    Cursor["cross"] = "cross";
})(Cursor || (Cursor = {}));
export default class PanZoom extends React.PureComponent {
    constructor(props) {
        super(props);
        this.zoomSvg = null;
        this.zoom = null;
        this.handleKeyDown = (e) => {
            if (e.key === "Control") {
                this.setState({ cursorType: Cursor.cross });
            }
        };
        this.handleKeyUp = (e) => {
            if (e.key === "Control") {
                this.setState({ cursorType: Cursor.hand });
            }
        };
        this.zoomed = () => {
            const { xScale, yScale, y2Scale } = this.state;
            const transform = event.transform;
            var new_xScale = transform.rescaleX(xScale);
            var new_yScale = transform.rescaleY(yScale);
            var new_y2ScaleDomain = y2Scale
                ? transform.rescaleY(y2Scale).domain()
                : undefined;
            this.props.onScaleChange(new_xScale.domain(), new_yScale.domain(), new_y2ScaleDomain);
        };
        this.configZoom = () => {
            const zoom = d3.zoom().on("zoom", () => {
                this.zoomed();
            });
            this.zoom = zoom;
        };
        const { xScale, yScale, y2Scale } = props;
        this.state = {
            xScale,
            yScale,
            y2Scale,
            cursorType: Cursor.hand,
        };
    }
    componentDidMount() {
        this.configZoom();
        const svg = select(this.zoomSvg);
        svg.call(this.zoom);
        svg.on("mousemove", this.props.onMousemove);
        window.addEventListener("keydown", this.handleKeyDown);
        window.addEventListener("keyup", this.handleKeyUp);
    }
    componentDidUpdate(prevProps) {
        const { yExtend, xExtend, y2Extend } = this.props;
        const svg = select(this.zoomSvg);
        if (yExtend === null || xExtend === null || y2Extend === null) {
            this.zoom.on("zoom", null);
            try {
                svg.call(this.zoom.transform, d3.zoomIdentity);
                const { xScale, yScale, y2Scale } = this.props;
                this.setState({
                    xScale,
                    yScale,
                    y2Scale,
                });
            }
            catch (_a) {
            }
            finally {
                this.zoom.on("zoom", () => {
                    this.zoomed();
                });
            }
        }
        if (prevProps.height !== this.props.height ||
            prevProps.width !== this.props.width) {
            const { xScale, yScale, y2Scale } = this.props;
            this.zoom.on("zoom", null);
            try {
                svg.call(this.zoom.transform, d3.zoomIdentity);
                this.setState({
                    xScale,
                    yScale,
                    y2Scale,
                });
            }
            catch (_b) {
            }
            finally {
                this.zoom.on("zoom", () => {
                    this.zoomed();
                });
            }
        }
    }
    componentWillUnmount() {
        const svg = select(this.zoomSvg);
        svg.on(".zoom", null);
        window.removeEventListener("keydown", this.handleKeyDown);
        window.removeEventListener("keyup", this.handleKeyUp);
    }
    render() {
        const { width, height, margins } = this.props;
        return (React.createElement("svg", { width: width - margins.right - margins.left > 0
                ? width - margins.right - margins.left
                : 0, height: height - margins.bottom - margins.top > 0
                ? height - margins.bottom - margins.top
                : 0, xmlns: "http://www.w3.org/2000/svg", className: `zoomSvg ${this.state.cursorType}`, ref: (ref) => {
                this.zoomSvg = ref;
            }, style: { top: `${margins.top}px`, left: `${margins.left}px` } },
            React.createElement("g", { transform: `translate(${-margins.left / 2}, ${margins.top})`, className: "zoomer" })));
    }
}
//# sourceMappingURL=PanZoom.js.map